export const preventDotsInInput = (event) => {
    if (event.key.charCodeAt(0) === 46) {
        event.preventDefault();
        event.stopPropagation();
    }
};
